<!-- 线索列表：列表组件 -->
<template lang="html">
  <div class="listContent">
    <div class="headline">
      <div class="left">
        <div class="sorts" v-if="sort">
          <div :class="{sort: true, active: filterKey == s.key}" v-for="(s, i) in sorts" :key="i" @click="toggleSort(s)">
            <span>{{s.title}}</span>
            <img src="@assets/img/common/up.svg" alt="up" v-if="filterKey === s.key">
          </div>
        </div>
        <div class="types" v-if="cate">
          <div :class="{type: true, active: t.key == filterKey}" :key='i' v-for="(t, i) in types" @click="toggleSort(t)">
            {{t.title}}
          </div>
        </div>
        <div class="fresh" :class="{internet: cate}" @click="fresh()">刷新</div>
        <div class="btn" v-if="showInclude" @click="showIncludes()">收录单</div>
      </div>
      <div class="new" @click="goClue()" v-if="showCreate">
        <img src="@assets/img/common/upload.svg" alt="upload">
        <span>{{`上传${$_syscfg.clue}`}}</span>
      </div>
    </div>
    <empty :mTop="30" v-if="list && list.length === 0" :msg="`暂无${$_syscfg.clue}数据`" />
    <div :class="{items: true,warn: report.has_warning}" v-for="(report, i) in list" :key="i">
      <img v-if="report.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
      <div class="item">
        <div class="avatar" v-if="listType === 5">
          <img :src="report.avatar || defaultImg" alt="avatar">
        </div>
        <div class="pic" :style="'background: url('+ report.cover +') no-repeat;background-size: 100% 100%;background-position: center center;'" v-else @click="viewMedia(report)">
          <div v-show="isChrome" class="backDrop"></div>
          <div v-show="!isChrome" :style="'background: url('+ report.cover +') no-repeat;'" class="blur"></div>
          <img @error="imgError(report)" class="main" :src="report.cover || defaultImg" alt="pic">
          <!-- <img class="main" :src="defaultImg" alt="default" v-if="!report.cover"> -->
          <img v-if="report.play_icon - 0 === 1 && report.cover" class="play" src="@assets/img/index/play.svg" alt="play" >
        </div>
        <div class="article">
          <div :class="{title: true, notWB: type !== 5}" @click="goDetail(report)">
            <p class="words" :title="report.title || report.username">
              {{report.title || report.username}}
            </p>
            <img src="@assets/img/common/tips.svg" alt="change" v-if="report.has_change - 0 === 1">
            <img src="@assets/img/common/new.svg" alt="new" v-if="report.is_new - 0 === 1">
            <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="report.has_img - 0 === 1">
            <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="report.has_video - 0 === 1">
            <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="report.has_sound - 0 === 1">
            <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="type !== 5&&report.has_audit&&report.has_audit==2" src="@assets/img/common/verify-fail.svg">
          </div>
          <p :class="{content: true, mt10: listType === 5, normal: type !== 5}">
            {{report.content}}
          </p>
          <div class="imgs" v-if="listType === 5">
            <div class="media" v-for="(img, imgidx) in report.img_list || []" @click="playMedia(report, img,imgidx)" :style="{'background-image': `url(${img.url || defaultImg})`}" :key="imgidx">
              <!-- <img :src="img.url || defaultImg" alt="img" :key="imgidx"> -->
            </div>
            <div class="media" v-for="(img, imgidx) in report.video_list || []" @click="playMedia(report, img,imgidx+report.img_list&&report.img_list.length||0)" :style="{'background-image': `url(${img.cover || defaultImg})`}" :key="imgidx+110">
              <!-- <img :src="img.cover || defaultImg" alt="img" :key="imgidx"> -->
              <div class='verify-success verify-item'  v-if="img.has_audit&&img.has_audit==1">
                <img alt="技审通过" title="技审通过" class="verify-logo" src="@assets/img/common/verify-success-logo.svg">    
              </div>
              <div class='verify-fail verify-item' v-if="img.has_audit&&img.has_audit==2">
                <img alt="技审未通过" title="技审未通过" class="verify-logo"  src="@assets/img/common/verify-fail-logo.svg">
              </div>
              <img class="play" src="@assets/img/index/play.svg" alt="play">
            </div>
          </div>
          <div class="footline" v-if="listType === 5">
            <p class="info">{{`${report.release_time} ${report.from_platform}`}}</p>
          </div>
          <div class="footline" v-else>
            <p class="mark">
              <img src="@assets/img/common/xy.svg" alt="user">
              <span>{{report.source_info.ptitle}}</span>
            </p>
            <p class="mark">
              <img src="@assets/img/common/zz.svg" alt="time">
              <span :class="{'card': type == 2 || type == 3}" @click="showCard(report.uid, $event)">
                {{report.username}}
              </span>
            </p>
            <p class="mark">
              <img src="@assets/img/index/time.svg" alt="time">
              <span>{{report.release_time}}</span>
            </p>
            <p class="mark caiyong">
              <img src="@assets/img/index/beUse.svg" alt="tv">
              <span>
                {{`被采用 ${report.reports.length}`}}
                <div class="tips" v-if="report.reports.length > 0">
                  <p v-for="(r, ri) in report.reports" :key='ri' class="tip" @click="goRptDtl(r)">
                    <img title="报道" v-if="r.type == 'report'" src="@assets/img/common/reportIcon.svg">
                    <img style="margin-left: 0.5px;margin-right: 12.5px" title="发布" v-if="r.type == 'publish' || r.type == 'new_media'" src="@assets/img/common/uploadIcon.svg">
                    <i :title="r.title" class="tiptitle">{{r.title}}</i>
                    <i class="tiper">{{r.user_name}}</i>
                    <i class="tiptime">{{r.raw_add_time}}</i>
                  </p>
                </div>
              </span>
            </p>
          </div>
        </div>
        <div class="handles">
          <div v-if="report.has_report_role || report.has_publish || report.has_new_media" class="pushBtn">
            <p :class="{on: report.showPushBtns}" @click="setShowPushBtns(i)">
              <span>推送</span>
              <i></i>
            </p>
            <div class="btn">
              <span></span>
              <ul>
                <li v-if="report.has_report_role && enablePush" @click="goReport(report,i)">{{`推送${$_syscfg.report}`}}</li>
                <li v-if="report.has_publish" @click="pushPublish(report.id, 'material', i)">{{`推送${$_syscfg.publish}`}}</li>
                <li v-if="report.has_new_media" @click="pushMedia(report, i)">{{`推新发布`}}</li>
              </ul>
            </div>
          </div>
          <div v-if="report.has_stream_send" class="threePoint">
            <i></i>
            <div class="btn">
              <span></span>
              <ul>
                <li @click="mediaSend(report.id, i)">{{`归档`}}</li>
              </ul>
            </div>
          </div>
          <!-- <div class="handle l" v-if="report.has_report_role && enablePush" @click="goReport(report)">
            {{`推送${$_syscfg.report}`}}
          </div>
          <div class="handle l" v-if="report.has_publish" @click="pushPublish(report.id, 'material')">
            {{`推送${$_syscfg.publish}`}}
          </div>
          <div class="handle l" v-if="report.has_new_media" @click="pushMedia(report)">
            {{`推新发布`}}
          </div> -->
        </div>
      </div>
    </div>
    <includeClues ref="includeClues" />
  </div>
</template>

<script>
import common from "@common/common";
import empty from "@components/empty";
import { apis } from "@common/config";
import includeClues from "@components/includeCluesList";
import vClickOutside from 'v-click-outside';

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  name: "listItem",
  components: { empty, includeClues },
  props: {
    list: {
      // type: Array,
      required: true,
      default: null
    },
    sort: {
      type: Boolean,
      default: false
    },
    cate: {
      type: Boolean,
      default: false
    },
    showCreate: {
      type: Boolean,
      default: false
    },
    showInclude: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1
    },
    enablePush: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      defaultImg: require("@assets/img/common/default.png"),
      sorts: [
        {
          title: "时间",
          key: "time"
        },
        {
          title: "被采用",
          key: "use_num"
        }
      ],
      types: [
        {
          title: "网站新闻",
          key: "1"
        },
        {
          title: "微博",
          key: "5"
        },
        {
          title: "微信",
          key: "6"
        }
      ],
      filterKey: "",
      listType: 1,
      isChrome: true
    };
  },
  methods: {
    mediaSend(id, index) {
      this.list[index].showThreePoint = false;
      let info = {
          subject_type: 0,
          subject_id: id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    setShowPushBtns(index) {
      this.list.forEach((el,key) => {
        if(key != index){
          el.showPushBtns = false;
        }
        el.showThreePoint = false;
      });
      this.list[index].showPushBtns = !this.list[index].showPushBtns      
    },
    setShowThreePoint(index) {
      this.list.forEach((el,key) => {
        if(key != index){
          el.showThreePoint = false;
        }
        el.showPushBtns = false;
      });
      this.list[index].showThreePoint = !this.list[index].showThreePoint      
    },
    async pushMedia(item,index) {
      console.log(item)
      const type = await this.$MediaPlatform('push');
      if (!type) return;
      console.log(type)
      this.list[index].showPushBtns = false;
      let info = {
          platforms: type,
          submit_type: 0,
          subject_type: 0,
          subject_id: item.id
      };

      common
      .myFetch(apis.newMediaPlatformCreate, info)
      .then(r => {
          if (r) {
              console.log(r)
              common.jump(`/createMediaPublish?d=${r.report_id}`, true);
          }
      });
      // common.jump(`/createMediaPublish?d=${type}`, true);
    },
    async pushPublish(id, t, index) {
      // 推送发布
      const type = await this.$pageType("publish");
      console.log('type', type)
      if (!type) return;
      this.list[index].showPushBtns = false;
      const info = {
        subject_id: id,
        subject_type: t,
        type: type
      };

      common.myFetch(apis.publish_pushPublish, info).then(r => {
        if (r) {
          const url = `/editPublish?t=${type}&d=${r.id}`;

          common.jump(url, true);
        }
      });
    },
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    showIncludes() {
      // 显示收录单弹窗
      this.$refs.includeClues.open('收录单');
    },
    imgError(i) {
      // 图片加载状态
      this.$set(i, "cover", this.defaultImg);
    },
    // 播放微博视频图片
    playMedia(data, item, index) {
      const now = {
        url: item.url,
        type: item.type - 0,
        downloadUrl: item.download_url
      };
      common.openMaterialBox(data, index, false);

    },
    // 浏览稿件媒体
    viewMedia(data) {
      common.openMaterialBox(data, null, false);
    },
    goClue() {
      // 创建线索
      common.jump("/creatClue?t=0", true);
    },
    async goReport(i,index) {
      const type = await this.$pageType();
      if (!type) return;
      this.list[index].showPushBtns = false;
      const info = {
        id: i.id,
        type: type
      };
      const newWindow = window.open();

      common.myFetch(apis.clue_toReport, info).then(r => {
        if (r) {
          const reportId = r.report_id;

          newWindow.location.href = `${window.location.origin
            }/creatReport?push=${i.id}&t=${type}&d=${reportId}`;

          // common.jump(`/creatReport?push=${i.id}&t=${type}&d=${reportId}`, true)
        }
      });
    },
    goDetail(i) {
      if (this.listType == 5) return;

      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);

      common.jump(`/clueDetail?d=${i.id}`, true);
    },
    goRptDtl(r) {
      if (!r.has_report_detail_role && !r.has_new_media_role) {
        this.$toast("无访问权限");
        return;
      }

      if (r.type == "report") {
        common.jump(`/reportDetail?d=${r.report_id}`, true);
      } else if (r.type == "publish") {
        common.jump(`/publishDetail?d=${r.report_id}`, true);
      } else if (r.type == "new_media") {
        common.jump(`/mediaPublishDetail?d=${r.report_id}`, true);
      }
    },
    toggleSort(s) {
      // 切换排序
      if (this.filterKey === s.key) {
        return;
      }

      this.filterKey = s.key;
      this.postKey();
    },
    postKey() {
      // 传递排序数据
      const data = {};

      if (this.sort) {
        data["sort_by"] = this.filterKey;
      }

      if (this.cate) {
        // data['medium_id'] = this.filterKey
        data["source_type"] = this.filterKey;

        this.listType = this.filterKey - 0;
      }

      this.$emit("getSort", data);
    },
    init() {
      // 默认选中第一项
      let item = {};
      if (this.sort) {
        item = this.sorts[0];
      }

      if (this.cate) {
        item = this.types[0];
      }

      this.filterKey = item.key;
      // this.toggleSort(item) // 列表首次请求从此发出
    },
    fresh() {
      // 无修改刷新列表
      this.$parent.getList();
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.init();
    this.listType = this.type;
    var agent = navigator.userAgent.toLowerCase();
    if(agent.indexOf("chrome") > 0) {
      this.isChrome = true
    }else{
      this.isChrome = false
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/global.less";
.blur {
  width: 100%;
  height: 100%;
  filter: blur(5px);
  background-position: center center !important;
  background-size: 100% 100% !important;
}

.backDrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
}
.listContent {
  // .boxOuter;
  display: flex;
  flex-direction: column;
  &>.empty {
    flex: 1;
  }
  flex: 1;
  // margin-top: 30px;
  .headline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    padding: 0 30px;
    border-bottom: 1px solid #f0f0f0;
    box-sizing: border-box;
    .left {
      display: flex;
      flex: 1;
      align-items: center;
      .btn {
        width: 72px;
        height: 32px;
        border: 1px solid @green;
        // background-color: #EBF6F2;
        background-color: fade(@green, 6);
        font-size: 14px;
        color: @green;
        text-align: center;
        line-height: 32px;
        margin-left: 30px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .fresh {
      // margin-left: 30px;
      margin-left: 15px;
      width: 50px;
      font-size: 14px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid @dc;
      color: @sub;

      &.internet {
        margin-left: 30px;
      }
    }
    .types {
      display: flex;
      .type {
        margin-right: 40px;
        height: 30px;
        font-size: 18px;
        color: @dateColor;
        border-bottom: 2px solid transparent;
        cursor: pointer;
        font-weight: bold;
        
        &:nth-last-of-type(1) {
          margin-right: 0;
        }
      }
      .active {
        color: @green;
        border-color: @green;
      }
    }
    .sorts {
      display: flex;
      border: 1px solid @dc;
      border-radius: 4px;
      overflow: hidden;
      .sort {
        background-color: rgba(185, 195, 195, 0.2);
        width: 85px;
        height: 30px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: @sub;
        justify-content: center;
        cursor: pointer;
      }
      .active {
        color: @green;
        background-color: #fff;
        justify-content: space-between;
      }
    }
    .new {
      padding: 10px 20px;
      background-color: @green;
      color: #fff;
      border-radius: 100px;
      display: flex;
      align-items: center;
      cursor: pointer;
      font-weight: bold;
      img {
        margin-right: 10px;
      }
      &:active {
        .btnActive;
      }
      &:hover {
        .btnHover;
      }
    }
  }
  .items:last-child {
    .item {
      border: none;
    }
  }
  .items {
    padding: 0 30px;
    position: relative;
    .warning {
      position: absolute;
      left: 0;
      top: 0;
    }
    &.warn {
      background: rgba(240, 193, 41, 0.15);
    }
    &:hover {
      .item {
        .handles {
          visibility: visible;
        }
      }
      background-color: rgba(185, 195, 195, 0.15);
    }
    .item {
      padding: 20px 0;
      min-height: 190px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      align-items: flex-start;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .pic {
        flex-shrink: 0;
        width: 240px;
        height: 135px;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .tags {
          position: absolute;
          padding: 4px 10px;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 4px 0 16px 0;
          img {
            margin-left: 8px;
            cursor: pointer;
          }
          img:first-child {
            margin-left: 0;
          }
        }
        .main {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: contain;
          background: transparent;
        }
        .play {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          // box-shadow:4px 4px 10px 0 rgba(5,10,15,0.05);
        }
      }
      .article {
        flex: 1;
        overflow: hidden;
        margin: 0 40px 0 30px;
        min-height: 135px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          // width: 0;
          overflow: hidden;
          cursor: pointer;
          display: flex;
          align-items: center;
          // &:hover {
          //   .words {
          //     color: @green;
          //   }
          // }
          .verify-logo {
            width: 22px;
          }
          .words {
            color: @dark;
            font-size: 18px;
            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          img {
            margin-left: 8px;
          }
        }
        .notWB {
          &:hover {
            .words {
              color: @green;
            }
          }
        }
        .content {
          color: @sub;
          font-size: 14px;
          line-height: 24px;
          text-align: justify;
        }
        .normal {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .mt10 {
          margin-top: 10px;
        }
        .imgs {
          display: flex;
          margin: 20px 0 0;
          flex-wrap: wrap;
          .media {
            width: 100px;
            height: 100px;
            margin-right: 10px;
            margin-bottom: 10px;
            border-radius: 4px;
            overflow: hidden;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            position: relative;
            .verify-item {
              position: absolute;
              left: 0;
              top: 0;
              background-color: @green;
              width: 20px;
              height: 20px;
              border-radius: 0 0 100% 0;
              z-index: 1;
              line-height: 10px;
              padding: 2px;
              &.verify-fail {
                background-color: #ff3e53;
              }
              img {
                width: 11px;
                height: 11px;
              }
            }
            cursor: pointer;
            img {
              display: block;
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
            .play {
              width: 50px;
              height: auto;
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              margin: auto;
            }
          }
        }
        .footline {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .info {
            color: @dateColor;
            font-size: 14px;
          }
          .caiyong {
            cursor: pointer;
          }
          .mark {
            display: flex;
            align-items: center;
            // flex: 1;
            overflow: hidden;
            margin-left: 40px;
            // position: relative;
            span {
              color: @dateColor;
              font-size: 14px;
              margin-left: 8px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              // cursor: pointer;
              &:hover {
                .tips {
                  display: block;
                }
              }
            }
            .tips {
              position: absolute;
              display: none;
              margin: 0 0 0 -142px;
              border-radius: 4px;
              overflow: hidden;
              background-color: rgba(5, 15, 15, 0.8);
              width: 340px;
              height: auto;
              padding: 5px 20px;
              box-sizing: border-box;
              z-index: 5;
              .tip {
                height: 20px;
                margin: 5px 0;
                display: flex;
                align-items: center;
                font-size: 14px;
                color: @dateColor;
                img {
                  margin-right: 10px;
                }
                .tiptitle {
                  color: #fff;
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .tiper {
                  width: 42px;
                  flex-shrink: 0;
                  margin-right: 10px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .tiptime {
                  flex-shrink: 0;
                  // width: 72px;
                }
                &:hover {
                  text-decoration: underline;
                }
              }
              &:hover {
                display: block;
              }
            }
          }
          .mark:first-child {
            margin: 0;
          }
        }
      }
      .greenBtn {
        background-color: @green !important;
        color: #fff !important;
      }
      .ml {
        margin-left: 140px;
      }
      .handles {
        flex-shrink: 0;
        // width: 230px;
        margin-top: 60px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        // visibility: hidden;
        .s {
          width: 40px;
        }
        .m {
          width: 60px;
        }
        .l {
          width: 70px;
        }
        .pushBtn {
          position: relative;
          margin-right: 10px;

          &:hover {
            .btn {
              display: flex;
            }

            i {
              transform: rotate(180deg);
            }
          }

          .btn {
            position: absolute;
            top: 30px;
            right: 0;
            display: none;
            flex-direction: column;

            span {
              display: block;
              width: 78px;
              height: 6px;
            }
          }

          ul {
            width: 78px;
            z-index: 9;
            background-color: rgba(5,15,15,0.8);
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            overflow: hidden;

            li {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 13px;
              font-weight: bold;
              color: #FFFFFF;
              user-select: none;
              cursor: pointer;

              &:hover {
                background: rgba(255, 255, 255, 0.1);
              }
            }
          }

          &>p {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 30px;
            padding: 0 6px 0 7px;
            line-height: 30px;
            background-color: @green;
            color: #fff;
            border-radius: 4px;
            font-size: 14px;
            box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
            cursor: pointer;
            font-weight: bold;
            box-sizing: border-box;

            &.on {
              i {
                transform: rotate(180deg);
              }
            }

            i {
              display: block;
              width: 13px;
              height: 7px;
              background: url('../assets/img/common/upArrow.png') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              margin-left: 6px;
              user-select: none;
              cursor: pointer;
            }
          }
        }
        .threePoint {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          height: 30px;
          background: #FFF;
          border-radius: 4px;
          box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
          cursor: pointer;

          &:hover {
            .btn {
              display: flex;
            }
          }

          .btn {
            position: absolute;
            top: 30px;
            right: 0;
            display: none;
            flex-direction: column;

            span {
              display: block;
              width: 78px;
              height: 6px;
            }
          }

          ul {
            width: 78px;
            background-color: rgba(5,15,15,0.8);
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            overflow: hidden;

            li {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 13px;
              font-weight: bold;
              color: #FFFFFF;
              user-select: none;
              cursor: pointer;

              &:hover {
                background: rgba(255, 255, 255, 0.1);
              }
            }
          }

          i {
            display: block;
            width: 30px;
            height: 30px;
            background: url('../assets/img/common/threeBtn.png') no-repeat;
            background-position: center center;
            background-size: 16px 4px;
          }
        }
        .handle {
          word-break: keep-all;
          background-color: #fff;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: @sub;
          font-size: 14px;
          box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
          cursor: pointer;
          margin-left: 10px;
          font-weight: bold;
          &:active {
            .btnActive;
          }
          &:hover {
            .btnHover;
          }
        }
        .handle:first-child {
          margin-left: 0;
          background-color: @green !important;
          color: #fff !important;
        }
      }
    }
  }
}
</style>
